import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AdminPage } from './components/AdminPage';
import { DroneLogo } from './components/DroneLogo';
import { DisplayPage } from './components/DisplayPage';
import './styles.css';

function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/display/drone-landscape') return <DroneLogo landscape />;
  if (path === '/display/drone-portrait') return <DroneLogo />;
  if (path === '/admin') return <AdminPage />;
  if (path === '/display' || path.startsWith('/display/')) {
    const slug = path.split('/')[2] || 'lounge';
    return <DisplayPage slug={slug} />;
  }
  return (
    <main className="route-missing">
      <div className="brand-lockup"><span>E</span><div>ELEVATION<small>DIGITAL SIGNAGE</small></div></div>
      <h1>Choose a destination.</h1>
      <div className="button-row"><a className="button button--primary" href="/admin">Admin</a><a className="button" href="/display/lounge">Lounge display</a></div>
    </main>
  );
}

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
